import React from 'react';
import Modal from './Modal';

export interface WarningItem {
  name: string;
  thumbnailUrl?: string;
}

interface WarningModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  items?: WarningItem[];
  onClose: () => void;
}

const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  title,
  message,
  items,
  onClose
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {/* Warning icon */}
      <div className="flex items-center justify-center w-14 h-14 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-amber-500 to-yellow-500 shadow-lg">
        <svg className="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>

      {/* Title */}
      <h3 className="text-xl font-bold text-gray-900 dark:text-white text-center mb-2">
        {title}
      </h3>

      {/* Message */}
      <p className="text-gray-600 dark:text-gray-300 text-center mb-4">
        {message}
      </p>

      {/* Item list */}
      {items && items.length > 0 && (
        <ul className="max-h-48 overflow-y-auto mb-6 space-y-2 text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-white/5 rounded-lg p-3">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-3">
              {item.thumbnailUrl ? (
                <img
                  src={item.thumbnailUrl}
                  alt={item.name}
                  className="w-10 h-10 rounded object-cover shrink-0 bg-gray-200 dark:bg-gray-700"
                />
              ) : (
                <div className="w-10 h-10 rounded bg-gray-200 dark:bg-gray-700 flex items-center justify-center shrink-0">
                  <svg className="w-5 h-5 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14" />
                  </svg>
                </div>
              )}
              <span className="truncate">{item.name}</span>
            </li>
          ))}
        </ul>
      )}

      {/* Close button */}
      <button
        type="button"
        onClick={onClose}
        className="w-full btn-primary"
      >
        OK
      </button>
    </Modal>
  );
};

export default WarningModal;
